import { MLM } from '@sunrise/tracking'

import { DecoratedEstate } from '../mapper/decoratedItemEstate.interface'
import { CompanyName, LikedAction, TypePaid, Variant } from './trackingUtils.enum'

export function getCompanyName(isOwnInventory: boolean): CompanyName {
    return isOwnInventory ? CompanyName.OWN_INVENTORY : CompanyName.IMMOWELT
}

export function getTypePaid(isOwnInventory: boolean): TypePaid {
    return isOwnInventory ? TypePaid.OWN_INVENTORY : TypePaid.IMMOWELT
}

export function getVariant(newestEstate: boolean): Variant {
    return newestEstate ? Variant.NEW : Variant.DEFAULT
}

export function getLikedAction(liked: boolean): LikedAction {
    return liked ? LikedAction.ADD : LikedAction.REMOVE
}

export function getPositionAsString(position: number): string {
    return position.toString()
}

export function buildMlmResultListItems(items: DecoratedEstate[]): MLM.Item[] {
    return items.map((item: DecoratedEstate) => ({
        id: item.exposeeId,
        type: getCompanyName(item.ownInventory),
        typePaid: getTypePaid(item.ownInventory),
        typePosition: item.position,
    }))
}
